import { StihlFileDTO } from "./stihl-file-dto";

export class StihlGalleryPostDTO {
    Status: boolean;
    Title: string;
    Path: string | null;
}

export class StihlGalleryDTO {
    IdGallery: string | null;
    Status: boolean;
    Title: string;
    Path: string;
}

export class StihlGalleryDataDTO {
    IdGalleryData: string | null;
    IdGallery: string;
    IdGalleryType: number;
    IdGalleryCampaign?: number;
    IdGalleryCategory?: number;
    IdGalleryFormat?: number;
    GalleryType: string;
    GalleryCampaign: string;
    GalleryCategory: string;
    GalleryFormat: string;
    Status: boolean;
    ElementDate: string;
    Title: string;
    Description: string;
    Hashcode: string;
    ImageFile: StihlFileDTO | null;
    File: StihlFileDTO | null;
    PublishDate: string | null;
    UnpublishDate: string | null;
    PositiveFilters: string[];
    NegativeFilters: string[];
    Words: string[];
    Path: string;
    ShowDownloadButton: boolean;
    ShowDate: boolean;
    View: boolean;
    ShowDescription: boolean;
    ExternalUrl:boolean;
    UrlOpenNew:boolean;
    Url:string;
}
export class StihlGalleryDataPostDTO {
    Status: boolean;
    IdGallery: string;
    IdGalleryType: number;
    IdGalleryCampaign?: number;
    IdGalleryCategory?: number;
    IdGalleryFormat?: number;
    ElementDate: string;
    Title: string;
    Description: string | null;
    ImageFile: File | null;
    File: File | null;
    PublishDate: string | null;
    UnpublishDate: string | null;
    PositiveFilters: string[] | null;
    NegativeFilters: string[] | null;
    Words: string[] | null;
}

export class StihlGallerySearchFilter {
    Id: string;
    Type: number;
    Format: number;
    Category: number;
    Campaign: number;
    Date: string;
    Words: string | null;
    Take: number | null;
    Year: number;
}

export class StihlGalleryDataLogDTO {
    IdGalleryData: string;
    IdLogType: number;

    constructor(IdGalleryData: string, IdLogType: number) {
        this.IdGalleryData = IdGalleryData;
        this.IdLogType = IdLogType;
    }
}
